<ng-container *ngIf="product$ | async as product">
  <ng-template
    [cxOutlet]="outlets.PRICE"
    [cxOutletContext]="{ product: product }"
  >
    <div *ngIf="product?.price?.formattedValue || currentPrice" class="prices">
      <ng-container *ngIf="product.purchasable || product.purchaseLabel?.netPrice">
        <div *ngIf="currentPrice" [attr.aria-label]="'productSummary.newItemPrice' | cxTranslate" class="price">
          {{ currentPrice.value | currency : currentPrice.currency }}
          <span *ngIf="currentPrice.value" class="net">NET</span>
        </div>
      </ng-container>
      <div *ngIf="!currentPrice && !noNetPrice" class="price">
        <div class="cx-spinner">
          <cx-spinner></cx-spinner>
        </div>
      </div>
      <div *ngIf="product?.price?.formattedValue" class="price-msr">
        <div class="msr-amount">{{ product?.price?.formattedValue }}</div>
        <span>{{product.servicePart ? 'MSLP' : 'MSRP'}}</span>
      </div>
    </div>
  </ng-template>


  <div class="product-badges-icons">
    <gen-sp-icons *ngIf="product.flammable || product.ltl || product.noAirFreight" [product]="product" [changeTooltipPosition]="true"></gen-sp-icons>
    
    <gen-product-badge *ngIf="product?.badges?.length" [badges]="product.badges" [size]="'large'"></gen-product-badge>
  </div>

  <ng-template
    [cxOutlet]="outlets.SUMMARY"
    [cxOutletContext]="{ product: product }"
  >
    <p
      *ngIf="product?.summary"
      [innerHTML]="product?.summary | safe"
      class="summary"
    ></p>
  </ng-template>

  <gen-no-return-warning *ngIf="isScratchAndDentOrReconditioned " [message]="scratchAndDentWarrantyInfo"></gen-no-return-warning>
  <gen-no-return-warning *ngIf="product.displayItemAttentionMessage" [message]="product.displayItemAttentionMessage"></gen-no-return-warning>
  <gen-no-return-warning *ngIf="product.excludedByRegion" [color]="'#F6E276'" [message]="exclusionMessage"></gen-no-return-warning>
  <gen-no-return-warning *ngIf="product.engineReplacement" [color]="'#F9E6E6'" [message]="atestationDataRestrictionMessage"></gen-no-return-warning>
  <gen-sp-info *ngIf="product.servicePart" [servicePart]="product" [onHand]="currentPrice?.onHand"></gen-sp-info>
</ng-container>
